import { axios } from "../../../lib/axios";

const reportDeliveryPayload = (props) => {
    return {
        resourceType: "ReportDelivery",
        ...props
    }
}

export const getReportDeliveries = (orgId) => {
  return axios.get(`report-delivery?${orgId ? `orgId=${orgId}`: ''}`)
}

export const createReportDelivery = (props) => {
    return axios.post(`report-delivery?orgId=${props.orgId}`, reportDeliveryPayload(props))
}

export const updateReportDelivery = (props) => {
    return axios.put(`report-delivery/${props.id}?orgId=${props.orgId}`, reportDeliveryPayload(props))
}

export const getReportDeliveryById = (id, orgId) => {
    return axios.get(`report-delivery/${id}?orgId=${orgId}`)
}

export const deleteReportDelivery = (id, orgId) => {
    return axios.delete(`report-delivery/${id}?orgId=${orgId}`)
}

const buildAuditQuery = ({
    orgId = null,
    encounterId = null,
    status = null,
    recordType = null,
    deliveryType = null,
    from = null,
    to = null,
    limit = null,
    nextToken = null,
} = {}) => {
    const params = new URLSearchParams();

    if (orgId && orgId !== "All") params.append("orgId", orgId);
    if (encounterId) params.append("encounterId", encounterId);
    if (status) params.append("status", status);
    if (recordType) params.append("recordType", recordType);
    if (deliveryType) params.append("deliveryType", deliveryType);
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    if (limit != null) params.append("limit", String(limit));
    if (nextToken) params.append("nextToken", nextToken);

    const query = params.toString();
    return query ? `report-delivery/audit?${query}` : "report-delivery/audit";
};

/** Super-Admin only. Modes: global (no orgId), org (orgId), encounter (orgId + encounterId). */
export const getReportDeliveryAudit = ({
    orgId = null,
    encounterId = null,
    status = null,
    recordType = null,
    deliveryType = null,
    from = null,
    to = null,
    limit = 50,
    nextToken = null,
} = {}) => {
    return axios.get(
        buildAuditQuery({
            orgId,
            encounterId,
            status,
            recordType,
            deliveryType,
            from,
            to,
            limit,
            nextToken,
        })
    );
};